var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightModeBlack24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_mode_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1216\\u66F4\\u65B0",
    transform: "translate(-415.000000, -726.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6\\u5907\\u4EFD",
    transform: "translate(125.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(0.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(16.000000, 68.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "light_mode_black_24dp",
    transform: "translate(274.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7 C9.24,7 7,9.24 7,12 C7,14.76 9.24,17 12,17 C14.76,17 17,14.76 17,12 C17,9.24 14.76,7 12,7 L12,7 Z M2,13 L4,13 C4.55,13 5,12.55 5,12 C5,11.45 4.55,11 4,11 L2,11 C1.45,11 1,11.45 1,12 C1,12.55 1.45,13 2,13 Z M20,13 L22,13 C22.55,13 23,12.55 23,12 C23,11.45 22.55,11 22,11 L20,11 C19.45,11 19,11.45 19,12 C19,12.55 19.45,13 20,13 Z M11,2 L11,4 C11,4.55 11.45,5 12,5 C12.55,5 13,4.55 13,4 L13,2 C13,1.45 12.55,1 12,1 C11.45,1 11,1.45 11,2 Z M11,20 L11,22 C11,22.55 11.45,23 12,23 C12.55,23 13,22.55 13,22 L13,20 C13,19.45 12.55,19 12,19 C11.45,19 11,19.45 11,20 Z M5.99,4.58 C5.6,4.19 4.96,4.19 4.58,4.58 C4.19,4.97 4.19,5.61 4.58,5.99 L5.64,7.05 C6.03,7.44 6.67,7.44 7.05,7.05 C7.43,6.66 7.44,6.02 7.05,5.64 L5.99,4.58 Z M18.36,16.95 C17.97,16.56 17.33,16.56 16.95,16.95 C16.56,17.34 16.56,17.98 16.95,18.36 L18.01,19.42 C18.4,19.81 19.04,19.81 19.42,19.42 C19.81,19.03 19.81,18.39 19.42,18.01 L18.36,16.95 Z M19.42,5.99 C19.81,5.6 19.81,4.96 19.42,4.58 C19.03,4.19 18.39,4.19 18.01,4.58 L16.95,5.64 C16.56,6.03 16.56,6.67 16.95,7.05 C17.34,7.43 17.98,7.44 18.36,7.05 L19.42,5.99 Z M7.05,18.36 C7.44,17.97 7.44,17.33 7.05,16.95 C6.66,16.56 6.02,16.56 5.64,16.95 L4.58,18.01 C4.19,18.4 4.19,19.04 4.58,19.42 C4.97,19.8 5.61,19.81 5.99,19.42 L7.05,18.36 Z",
    id: "\\u5F62\\u72B6",
    fill: "#D0D0D0",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeBlack24Dp);
export default __webpack_public_path__ + "static/media/light_mode_black_24dp.a3e3a22b3da8bcc4b80f0cf51c903567.svg";
export { ForwardRef as ReactComponent };